import React from 'react';
import {RoutePermittedRole} from '@crema/constants/AppEnums';
import {TbDeviceDesktopAnalytics} from 'react-icons/tb';
import {BiSolidCategoryAlt} from 'react-icons/bi';
import {MdOutlineInventory2} from 'react-icons/md';
import {
  FaCodepen,
  FaQuoteLeft,
  FaStar,
  FaListOl,
  FaStore,
  FaFileInvoiceDollar,
  FaEnvelope,
} from 'react-icons/fa';
import {
  MdBuild,
  MdLightbulb,
  MdVerified,
  MdSettings,
  MdArticle,
} from 'react-icons/md';

const routesConfig = [
  {
    id: 'user',
    title: 'Users',
    messageId: 'Home',
    type: 'item',
    // permittedRole: [RoutePermittedRole.Admin],
    icon: <TbDeviceDesktopAnalytics />,
    url: '/Home',
  },
  {
    id: 'website-content',
    title: 'Website Content',
    messageId: 'sidebar.websiteContent',
    type: 'group',
    children: [
      {
        id: 'cms-category',
        title: 'Categories',
        messageId: 'sidebar.categories',
        type: 'item',
        icon: <BiSolidCategoryAlt />,
        url: '/website/category',
        permittedRole: [RoutePermittedRole.Admin],
      },
      {
        id: 'cms-product',
        title: 'Products',
        messageId: 'sidebar.products',
        type: 'item',
        icon: <MdOutlineInventory2 />,
        url: '/website/product',
        permittedRole: [RoutePermittedRole.Admin],
      },
      {
        id: 'cms-service',
        title: 'Services',
        messageId: 'sidebar.services',
        type: 'item',
        icon: <MdBuild />,
        url: '/website/service',
        permittedRole: [RoutePermittedRole.Admin],
      },
      {
        id: 'cms-feature',
        title: 'Features',
        messageId: 'sidebar.features',
        type: 'item',
        icon: <MdLightbulb />,
        url: '/website/feature',
        permittedRole: [RoutePermittedRole.Admin],
      },
      {
        id: 'cms-faq',
        title: 'FAQs',
        messageId: 'sidebar.faqs',
        type: 'item',
        icon: <FaQuoteLeft />,
        url: '/website/faq',
        permittedRole: [RoutePermittedRole.Admin],
      },
      {
        id: 'cms-testimonial',
        title: 'Testimonials',
        messageId: 'sidebar.testimonials',
        type: 'item',
        icon: <FaStar />,
        url: '/website/testimonial',
        permittedRole: [RoutePermittedRole.Admin],
      },
      {
        id: 'cms-trust-item',
        title: 'Trust Items',
        messageId: 'sidebar.trustItems',
        type: 'item',
        icon: <MdVerified />,
        url: '/website/trust-item',
        permittedRole: [RoutePermittedRole.Admin],
      },
      {
        id: 'cms-process-step',
        title: 'Process Steps',
        messageId: 'sidebar.processSteps',
        type: 'item',
        icon: <FaListOl />,
        url: '/website/process-step',
        permittedRole: [RoutePermittedRole.Admin],
      },
      {
        id: 'website-pages',
        title: 'Pages',
        messageId: 'sidebar.websitePages',
        type: 'item',
        icon: <MdArticle />,
        url: '/website/pages',
        permittedRole: [RoutePermittedRole.Admin],
      },
      {
        id: 'cms-site-settings',
        title: 'Site Settings',
        messageId: 'sidebar.siteSettings',
        type: 'item',
        icon: <MdSettings />,
        url: '/website/site-settings',
        permittedRole: [RoutePermittedRole.Admin],
      },
      {
        id: 'cms-wholesale-application',
        title: 'Wholesale Applications',
        messageId: 'sidebar.wholesaleApplications',
        type: 'item',
        icon: <FaStore />,
        url: '/website/wholesale-application',
        permittedRole: [RoutePermittedRole.Admin],
      },
      {
        id: 'cms-quote-request',
        title: 'Quote Requests',
        messageId: 'sidebar.quoteRequests',
        type: 'item',
        icon: <FaFileInvoiceDollar />,
        url: '/website/quote-request',
        permittedRole: [RoutePermittedRole.Admin],
      },
      {
        id: 'cms-contact-message',
        title: 'Contact Messages',
        messageId: 'sidebar.contactMessages',
        type: 'item',
        icon: <FaEnvelope />,
        url: '/website/contact-message',
        permittedRole: [RoutePermittedRole.Admin],
      },
    ],
  },
  // {
  //   id: 'manage',
  //   title: 'Manage',
  //   messageId: 'sidebar.manage',
  //   type: 'group',
  //   children: [
  //     {
  //       id: 'blog',
  //       title: 'Blog',
  //       messageId: 'Blogs',
  //       type: 'collapse',
  //       icon: 'rss_feed',
  //       children: [
  //         {
  //           id: 'create-blog',
  //           title: 'create-blog',
  //           messageId: 'Create',
  //           type: 'item',
  //           url: '/create-blog',
  //         },
  //         {
  //           id: 'list',
  //           title: 'listing',
  //           messageId: 'List',
  //           type: 'item',
  //           url: '/blog-listing',
  //         },
  //       ],
  //     },
  //     {
  //       id: 'portfolio',
  //       title: 'portfolio',
  //       messageId: 'Portfolio',
  //       type: 'collapse',
  //       icon: <FaCodepen />,
  //       children: [
  //         {
  //           id: 'create-portfolio',
  //           title: 'create-portfolio',
  //           messageId: 'Create',
  //           type: 'item',
  //           url: '/create-portfolio',
  //         },
  //         {
  //           id: 'portfolio-list',
  //           title: 'portfolio-list',
  //           messageId: 'List',
  //           type: 'item',
  //           url: '/portfolio-listing',
  //         },
  //       ],
  //     },
  //     // {
  //     //   id: 'categories',
  //     //   title: 'categories',
  //     //   messageId: 'Categories',
  //     //   type: 'item',
  //     //   url: '/categories',
  //     //   icon: <BiSolidCategoryAlt />,
  //     // },
  //   ],
  // },
];
export default routesConfig;
